import { ref, Ref, ExtractPropTypes } from 'vue'
import { selectProps } from '../select'

type SelectProps = ExtractPropTypes<typeof selectProps>

export interface SelectOptionDataHookStates {
	filterValue?: Ref<string>
	inputValue?: Ref<string>
	multipleInputValue?: Ref<string>
	multipleFilterValue?: Ref<string>
}

export function useSelectOptionData({
	props,
	externalStates,
}: {
	props: SelectProps
	externalStates?: SelectOptionDataHookStates
}) {
	const selected = ref<any>(props.multiple ? [] : null) // 更合理的初始值

	if (externalStates) {
		console.log(externalStates)
	}

	return {
		selected,
	}
}
